exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  margin: 30px auto;\n  width: 70px;\n  text-align: center;\n}\n.loader > div {\n  width: 18px;\n  height: 18px;\n  background-color: #007bff;\n  border-radius: 100%;\n  display: inline-block;\n  animation: bounce-delay 1.4s infinite ease-in-out both;\n}\n.loader .dot1 {\n  animation-delay: -0.32s;\n}\n.loader .dot22 {\n  animation-delay: -0.16s;\n}\n@keyframes bounce-delay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n", ""]);

// exports
